export const PENDING_TEAM_ACTION = 'PENDING_TEAM_ACTION'
export const RECEIVE_DELETE_TEAM = 'RECEIVE_DELETE_TEAM'
export const RECEIVE_DELETE_TEAM_MEMBER = 'RECEIVE_DELETE_TEAM_MEMBER'
export const RECEIVE_NEW_TEAM = 'RECEIVE_NEW_TEAM'
export const RECEIVE_TEAM = 'RECEIVE_TEAM'
export const RECEIVE_TEAMS = 'RECEIVE_TEAMS'
export const RESET_TEAM_ACTION = 'RESET_TEAM_ACTION'
